export default __webpack_public_path__ + "static/media/img_company_header23.5ec82089.png";